import moment, { Moment } from 'moment';

export class DateRange {
  endDate: Moment = moment();
  beginDate: Moment = moment().subtract(1, 'months');
}
